<section class="section">
  <header
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    [ngClass]="expanded ? 'expanded' : 'collapsed'"
    tabindex="0"
    [title]="[(expanded ? 'Hide ' : 'Show ') + 'String format for this field']"
    >
    <mat-icon fontIcon="abc"></mat-icon>
    <h3>
      Format string field
      @if (hasChanged) {
        <span class="has-changed-indicator" title="Update field changes below">*</span>
      }
    </h3>
    <mat-icon fontIcon="expand_more" class="expand-icon"></mat-icon>
  </header>
  @if (expanded) {
    <table class="table-full-width" @configSectionsInOut>
      <tr>
        <td><p>HTML Options</p></td>
      </tr>
      <tr>
        <td>
          <mat-slide-toggle [(ngModel)]="containsHtml" (change)="updateHtml($event)">Contains HTML</mat-slide-toggle>
        </td>
      </tr>
      @if (containsHtml) {
        <div>
          <tr>
            <td>
              <mat-button-toggle-group
                name="substringOptions"
                aria-label="Substring options"
                [(ngModel)]="htmlProcess"
                (change)="updateConfig()"
                [hideSingleSelectionIndicator]="true"
                >
                <mat-button-toggle [value]="HtmlProcess.renderHtml" title="Show the HTML content with formatting">Show HTML</mat-button-toggle>
                <mat-button-toggle [value]="HtmlProcess.removeHtmlTags" title="Remove HTML formatting from text"
                  >Remove HTML Tags</mat-button-toggle
                  >
                </mat-button-toggle-group>
              </td>
            </tr>
          </div>
        }
        @if (!containsHtml) {
          <div>
            <tr>
              <td><p>Range</p></td>
            </tr>
            <tr class="button-toggle-grid">
              <td class="scrollable-container">
                <mat-button-toggle-group
                  name="substringOptions"
                  aria-label="Substring options"
                  [(ngModel)]="substringType"
                  (change)="updateConfig()"
                  [hideSingleSelectionIndicator]="true"
                  >
                  <mat-button-toggle [value]="StringFormatSubstring.NONE" title="No substring options applied">None</mat-button-toggle>
                  <mat-button-toggle [value]="StringFormatSubstring.START" title="The number of characters to display from the start">
                    <mat-icon fontIcon="last_page"></mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle [value]="StringFormatSubstring.END" title="The number of characters to display from the end">
                    <mat-icon fontIcon="first_page"></mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle [value]="StringFormatSubstring.RANGE" title="The first and last characters to display">
                    <mat-icon fontIcon="settings_ethernet"></mat-icon>
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </td>
            </tr>
            @if (substringType !== StringFormatSubstring.NONE) {
              <tr>
                @if (substringType === StringFormatSubstring.START) {
                  <td>
                    <p>Select characters from start</p>
                  </td>
                }
                @if (substringType === StringFormatSubstring.END) {
                  <td>
                    <p>Select characters from end</p>
                  </td>
                }
                @if (substringType === StringFormatSubstring.RANGE) {
                  <td>
                    <p>Select range</p>
                  </td>
                }
                @if (substringType === StringFormatSubstring.START || substringType === StringFormatSubstring.END) {
                  <td class="range-options-grid">
                    @if (substringType === StringFormatSubstring.START) {
                      <input
                        type="number"
                        placeholder="Characters from start..."
                        title="The number of characters to display from the start"
                        [(ngModel)]="substringFromStart"
                        [min]="min"
                        [max]="max"
                        (change)="updateConfig()"
                        appWholeNumberOnly
                        />
                    }
                    @if (substringType === StringFormatSubstring.END) {
                      <input
                        type="number"
                        placeholder="Characters from end..."
                        title="The number of characters to display from the end"
                        [(ngModel)]="substringFromEnd"
                        [min]="min"
                        [max]="max"
                        (change)="updateConfig()"
                        appWholeNumberOnly
                        />
                    }
                  </td>
                }
                @if (substringType === StringFormatSubstring.RANGE) {
                  <td class="range-options-grid">
                    <input
                      type="number"
                      placeholder="Range start..."
                      title="The first character to display"
                      [(ngModel)]="substringRangeStart"
                      [min]="min"
                      [max]="max"
                      (change)="updateConfig()"
                      appWholeNumberOnly
                      />
                      <input
                        type="number"
                        placeholder="Range end..."
                        title="The last character to display"
                        [(ngModel)]="substringRangeEnd"
                        [min]="min"
                        [max]="max"
                        (change)="updateConfig()"
                        appWholeNumberOnly
                        />
                      </td>
                    }
                  </tr>
                }
                <tr>
                  <td>
                    <p title="Tip: You can widen the Word Addin if you need more width">Capitalisation</p>
                  </td>
                </tr>
                <tr class="button-toggle-grid">
                  <td class="scrollable-container horizontal-scroll">
                    <mat-button-toggle-group
                      name="capitalisation"
                      aria-label="Capitalisation"
                      [(ngModel)]="capitalisation"
                      (change)="updateConfig()"
                      [hideSingleSelectionIndicator]="true"
                      >
                      <mat-button-toggle title="No changes to capitalisation." [value]="StringFormatCapitalisation.NONE">None</mat-button-toggle>
                      <mat-button-toggle title="Upper case all letters." [value]="StringFormatCapitalisation.ALL_UPPER">ABC</mat-button-toggle>
                      <mat-button-toggle title="Lower case all letters." [value]="StringFormatCapitalisation.ALL_LOWER">abc</mat-button-toggle>
                      <mat-button-toggle
                        title="Upper case the first letter of each word. Lower case all other letters."
                        [value]="StringFormatCapitalisation.CAP_ALL"
                        >Abc Def</mat-button-toggle
                        >
                        <mat-button-toggle
                          title="Upper case the first letter only. Lower case all other letters."
                          [value]="StringFormatCapitalisation.CAP_FIRST"
                          >Abc def</mat-button-toggle
                          >
                          <mat-button-toggle
                            title="Lower case the first letter only. Upper case all other letters."
                            [value]="StringFormatCapitalisation.UNCAP_FIRST"
                            >aBC DEF</mat-button-toggle
                            >
                          </mat-button-toggle-group>
                        </td>
                      </tr>
                    </div>
                  }
                </table>
              }
            </section>
